import { render, staticRenderFns } from "./sendMange.vue?vue&type=template&id=0fd8ada4&scoped=true"
import script from "./sendMange.vue?vue&type=script&lang=js"
export * from "./sendMange.vue?vue&type=script&lang=js"
import style0 from "./sendMange.vue?vue&type=style&index=0&id=0fd8ada4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8ada4",
  null
  
)

export default component.exports